import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as statisticActions from '../../actions/statistics';
import Loading from '../../components/loading';
import LocalizedStrings from '../../localization/strings';

import {Chart} from 'react-google-charts'

class HomeContainer extends Component {
    componentWillMount() {
        this.props.actions.fetchStatistics();
    }

    getIncomeChartData() {
        if (!this.props.statistics.item.incomeData) {
            return [];
        }
        let data = [
            [LocalizedStrings.stage, LocalizedStrings.income]
        ];
        this.props.statistics.item.incomeData.forEach((stageIncome) => {
            data.push([stageIncome.stageName, parseFloat(stageIncome.sum)])
        });
        return data;
    }

    getParticipantsChartData() {
        if (!this.props.statistics.item.participantsData) {
            return [];
        }
        let data = [
            [LocalizedStrings.stage, LocalizedStrings.participants]
        ];
        this.props.statistics.item.participantsData.forEach((stageIncome) => {
            data.push([stageIncome.name, parseFloat(stageIncome.count)])
        });
        return data;
    }

    render() {

        if (this.props.statistics.loading) {
            return (
                <div><Loading/></div>
            )
        }

        return (
            <div>
              <div className="chart-item">
                  <h3 className="title">{LocalizedStrings.income}</h3>
                  <Chart chartType="LineChart" data={this.getIncomeChartData()} options={{}} graph_id="IncomeChart" width="100%" height="400px" legend_toggle/>
              </div>
              <div className="chart-item">
                  <h3 className="title">{LocalizedStrings.participants}</h3>
                  <Chart chartType="LineChart" data={this.getParticipantsChartData()} options={{}} graph_id="ParticipantsChart" width="100%" height="400px" legend_toggle/>
              </div>
            </div>
        )
    }
}

export default connect(function(state) {
    return {statistics: state.statistics.statistics};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...statisticActions
        }, dispatch)
    };
})(HomeContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/dashboard-container.js